import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Box, Container, Fab } from "@mui/material";
import PropagateLoader from "react-spinners/PropagateLoader";
import Typewriter from "typewriter-effect";
import { useAPI } from "../../../../apiContext";
import { Wave } from "react-animated-text";

const Banner = () => {
	const { data } = useAPI();

	return (
		<Container sx={{ pt: 3 }}>
			<Box
				sx={{
					border: "3px solid",
					borderRadius: "15px",
					pb: 1,
					overflow: "hidden",
				}}
				className='borderColor'>
				{data?._id ? (
					<Card
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							boxShadow: 0,
							position: "relative",
							backgroundColor: "transparent",
						}}>
						<CardMedia
							className='bannerPhoto'
							component='img'
							alt=''
							sx={{
								height: "100%",
								position: "relative",
								backgroundSize: "cover",
								objectFit: "fill",
							}}
							image={data?.banner?.imageLink2 || "/sample-banner.jpg"}
						/>
						<Box
							sx={{
								height: { md: 200, xs: 150 },
								width: { md: 200, xs: 150 },
								mt: { md: -11, xs: -7 },
								position: "relative",
							}}>
							<CardMedia
								className='profilePhoto'
								sx={{
									boxShadow: 11,
									borderRadius: "50%",
									width: "100%",
									height: "100%",
								}}
								component='img'
								alt={data?.headline?.title}
								image={data?.profile?.imageLink2 || "/user.jpg"}
							/>
						</Box>
						<CardContent>
							<Typography
								className='textColor title'
								sx={{ fontWeight: 500, fontSize: "2rem" }}
								component='div'
								gutterBottom>
								<Wave
									text={data?.headline?.title}
									effect='jump'
									effectChange={0.5}
									delay={2}
								/>
							</Typography>
							<Typography
								className='textColor'
								sx={{ fontWeight: 700, fontSize: "1.4rem" }}
								component='div'>
								<Typewriter
									options={{
										strings: [`${data?.headline?.subtitle || ""}`],
										autoStart: true,
										loop: true,
									}}
								/>
							</Typography>
							{data?.details?.shortDetails !== "off" && (
								<Typography
									className='textColor'
									gutterBottom
									sx={{ whiteSpace: "pre-line", fontSize: "1rem", mt: 1.5 }}>
									{data?.details?.shortDetails}
								</Typography>
							)}
						</CardContent>{" "}
						{data?.details?.callNow !== "off" && (
							<Fab
								onClick={() =>
									window.open(`tel:${data?.details?.callNow}`, "_blank")
								}
								variant='extended'
								sx={{
									px: 4,
									fontWeight: "bold",
								}}>
								Call Now
							</Fab>
						)}
					</Card>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
		</Container>
	);
};

export default Banner;
